// extracted by mini-css-extract-plugin
export default {"wrapper":"YD-z","viewport":"ZD-z","container":"_D-z","slide":"aE-z"};